export enum BoxQuestionnaireSelectType {
  ByUser = 'BY_USER',
  BySystem = 'BY_SYSTEM',
}
